"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProfileOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M26,8.59,20.41,3A3.733,3.733,0,0,0,18,2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V11A3.733,3.733,0,0,0,26,8.59ZM19,4.41,24.59,10H19ZM25,28H7V4H17v7a1,1,0,0,0,1,1h7Z"/><path d="M20,18h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/><path d="M20,22h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/><circle cx="12" cy="12" r="2"/><path d="M16,20H10a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/><path d="M16,24H10a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/><path d="M10,18a1,1,0,0,0,1-1V16h2v1a1,1,0,0,0,2,0V16a2,2,0,0,0-2-2H11a2,2,0,0,0-2,2v1A1,1,0,0,0,10,18Z"/><path d="M20,26h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/>';
var ProfileOutlineSVG = function ProfileOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ProfileOutlineSVG = ProfileOutlineSVG;
ProfileOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ProfileOutlineSVG);
exports.default = _default;